import { render, staticRenderFns } from "./main-insights.vue?vue&type=template&id=04bafcbf&scoped=true&"
import script from "./main-insights.vue?vue&type=script&lang=js&"
export * from "./main-insights.vue?vue&type=script&lang=js&"
import style0 from "./main-insights.vue?vue&type=style&index=0&id=04bafcbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bafcbf",
  null
  
)

export default component.exports